import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names, last-writer-wins on conflicting utilities.
 *
 * The helper every shadcn component imports as `@/lib/utils`. `clsx` resolves
 * the conditional forms; `tailwind-merge` then drops the earlier class in a
 * conflicting pair, so a `className` prop can override a component's defaults
 * instead of racing them on source order.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
